
import { put, call } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { startSubmit, stopSubmit, reset } from 'redux-form'

import * as colors from 'material-ui/styles/colors';

import moment from 'moment'

import * as commons from '../commons'
import * as actions from '../actions'

export function* handleInit(action) {

  let date = new Date()
  let year = date.getFullYear()

  const resCheck = yield call(fetchData, year)

}

export function* handleChangeYear(action) {

  const resCheck = yield call(fetchData, action.payload.year)

}


function* fetchData(year) {

  yield put(actions.reducerAppLoading(true))

  const res = yield call(commons.get2, `/bg/master/bizHoliday/${year}`)

  const resCheck = yield call(errorCheck, res)
  if (!resCheck) {
    return
  }

  yield put(actions.reducerBizHolidayInit(year, res.result))

  yield call(delay, 300)

  yield put(actions.reducerAppLoading(false))

}


export function* handleRegist(action) {

  const { form } = action.payload

  yield put(startSubmit(`bizHolidayMasterForm`))
  yield put(actions.reducerAppLoading(true))

  let newForm = {
    year: form.year,
  }

  for (let i = 0; i < 12; i++) {
    newForm["month" + (i + 1)] = yield call(convertDate, form["month" + (i + 1)])
  }

  const registRes = yield call(commons.post2, `/bg/master/bizHoliday/`, newForm)

  const registCheck = yield call(errorCheck, registRes)
  if (!registCheck) {
    return
  }

  const fetchRes = yield call(commons.get2, `/bg/master/bizHoliday/${form.year}`)

  const fetchResCheck = yield call(errorCheck, fetchRes)
  if (!fetchResCheck) {
    return
  }

  yield put(actions.reducerBizHolidayInit(form.year, fetchRes.result))

  yield call(delay, 300)

  yield put(stopSubmit(`bizHolidayMasterForm`))

  yield put(actions.reducerYosanSetTransition(true))
  yield put(actions.reducerSnackBar(true, '登録しました。', colors.green400))
  yield put(actions.reducerAppLoading(false))

}

function* convertDate(list) {
  return list.map(x => {

    return {
      date: moment(new Date(x.date)).format('YYYY/MM/DD'),
      kind: x.kind,
      comment: x.comment,
      holidayKind: x.holidayKind,
    }
  })
}

function* errorCheck(res) {

  if (!res) {
    yield put(stopSubmit(`bizHolidayMasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.status && res.status == 401) {
    yield put(actions.reducerSnackBar(true, 'セッションタイムアウト（30分）しました。', colors.red400))
    yield put(stopSubmit(`bizHolidayMasterForm`))
    yield put(actions.reducerSetAuth({}, 9))
    yield put(actions.reducerAppLoading(false))
    return
  }

  if (res.fetchError || (res.status && res.status != 200)) {
    yield put(stopSubmit(`bizHolidayMasterForm`))
    yield put(actions.reducerSnackBar(true, '通信処理に失敗しました。', colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  if (res.error) {
    const { field, message } = res.error
    yield put(stopSubmit(`bizHolidayMasterForm`, { ...field }))
    yield put(actions.reducerSnackBar(true, message, colors.red400))
    yield put(actions.reducerAppLoading(false))
    return false
  }

  return true
  }


// WEBPACK FOOTER //
// ./src/sagas/bizHoliday.js